'use client';
import Link from 'next/link';
import { Mail } from 'lucide-react';
import { Github, Linkedin } from '@/components/ui/Icons';

const WHATSAPP = process.env.NEXT_PUBLIC_WHATSAPP_NUMBER || '923001234567';

export default function Footer() {
  return (
    <footer style={{
      background: 'var(--bg-surface)',
      borderTop: '1px solid var(--border)',
      padding: '3rem 0 2rem',
      marginTop: '4rem',
    }}>
      <div className="container">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1.5rem', marginBottom: '2rem' }}>
          <div>
            <p style={{ fontFamily: 'Outfit, sans-serif', fontWeight: 700, fontSize: '1.2rem', color: 'var(--text-primary)' }}>
              <span style={{ color: 'var(--accent)' }}>{'<'}</span>farooqiumershah<span style={{ color: 'var(--accent)' }}>{'/>'}</span>
            </p>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', marginTop: '0.25rem' }}>Full Stack Developer</p>
          </div>
          <div style={{ display: 'flex', gap: '1rem' }}>
            <a href="https://github.com/" target="_blank" rel="noopener noreferrer" aria-label="GitHub"
              style={{ width: '40px', height: '40px', borderRadius: '50%', background: 'var(--bg-card)', border: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-muted)', transition: 'all 0.2s' }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--accent)'; e.currentTarget.style.color = 'var(--accent)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.color = 'var(--text-muted)'; }}
            ><Github size={16} /></a>
            <a href="https://linkedin.com/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"
              style={{ width: '40px', height: '40px', borderRadius: '50%', background: 'var(--bg-card)', border: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-muted)', transition: 'all 0.2s' }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--accent)'; e.currentTarget.style.color = 'var(--accent)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.color = 'var(--text-muted)'; }}
            ><Linkedin size={16} /></a>
            <a href={`mailto:${process.env.NEXT_PUBLIC_EMAIL}`} aria-label="Email"
              style={{ width: '40px', height: '40px', borderRadius: '50%', background: 'var(--bg-card)', border: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-muted)', transition: 'all 0.2s' }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--accent)'; e.currentTarget.style.color = 'var(--accent)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.color = 'var(--text-muted)'; }}
            ><Mail size={16} /></a>
          </div>
        </div>
        <div style={{ borderTop: '1px solid var(--border)', paddingTop: '1.5rem', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
          <p style={{ color: 'var(--text-subtle)', fontSize: '0.85rem' }}>© {new Date().getFullYear()} Muhammad Umer Shah Farooqi. All rights reserved.</p>
          <p style={{ color: 'var(--text-subtle)', fontSize: '0.85rem' }}>Built with Django + Next.js 🚀</p>
        </div>
      </div>
    </footer>
  );
}
